// extracted by mini-css-extract-plugin
export var cell = "_63-4";
export var headerCell = "_63-2";
export var rowHeader = "_63-3";
export var table = "_63-1";
export var tableContainer = "_63-0";